import styled from 'styled-components';

import { min } from '../../utils/breakpoints';

const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
`;

const Th = styled.th`
  padding: 10px 10px 25px;
  border: none;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: ${(props) => props.color};
  border-bottom: 1px solid ${(props) => props.theme.colors.light};

  ${min.sm} {
    font-size: 16px;
  }
`;

const Td = styled.td`
  padding: 12px;
  border: none;
  font-size: 12px;
  text-align: ${(props) => (props.center ? 'center' : 'left')};
  border-bottom: 1px solid ${(props) => props.theme.colors.light};

  tr:last-child & {
    border-bottom: none;
  }

  ${min.sm} {
    font-size: 16px;
  }
`;

StyledTable.Th = Th;
StyledTable.Td = Td;

export default StyledTable;
